import ArticleHeaderImage from 'lib/posts/components/ArticleHeaderImage';
import { MerchantDetail } from 'lib/shop/types';
import React from 'react';

export default function MerchantHero({
  merchant,
}: {
  merchant: MerchantDetail;
}) {
  return (
    <div className="mb-2 py-5">
      <ArticleHeaderImage
        image={merchant.hero_images?.[0]}
        alt={merchant.title}
        wideImage={merchant.hero_wide_images?.[0]}
      />
    </div>
  );
}
